<header class="subnav-hero-section">
  <h1 class="subnav-hero-headline">{{ title }}</h1>
  <ul class="subnav-hero-subnav">
    @for (menuItem of menuItems; track menuItem; let i = $index) {
      <li><a routerLink="{{menuItem.url}}" >{{ menuItem.title }}</a></li>
    }
  </ul>
</header>
